import { ReactElement, ReactNode } from 'react';

import { ActionBar } from '@dreryk/react-components';

type WaitlistActionBarProps = {
   children: ReactNode;
};

export const WaitlistActionBar = (props: WaitlistActionBarProps): ReactElement => {
   return (
      <ActionBar testId={'waitlist'} id={'waitlist-action-bar'}>
         {props.children}
      </ActionBar>
   );
};
